import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Redirect, Stack } from "expo-router";
import { useAuth } from "@/context/AuthContext";

export default function ChangePasswordLayout() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) return null;

  if (!isAuthenticated || !user) {
    return <Redirect href="/(auth)/login" />;
  }

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        header: (props) => <ScreenHeader title="auth.changePassword.headerTitle" {...props} />,
      }}
    />
  );
}
